import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import './rpt_ejecucion_siembra.css'
import TablaEjecucionSemana from './TablaEjecucionSemana';
import TablaEjecucionBloque from './TablaEjecucionBloque';

const Rpt_ejecucion_siembra = () => {

    const [selecciones, setselecciones] = useState({ semana_inicio: '', semana_fin: '', flor_id: '', variedad_id: '', color_id: '', descartar_ceros: false });
    const [reporte, setreporte] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [flores, setflores] = useState([]);
    const [variedades, setvariedades] = useState([]);
    const [colores, setcolores] = useState([]);
    const [visor, setvisor] = useState({ tipo_visualizacion: 'semana' });
    useEffect(() => {
        getReporte();
    }, []);

    const semanaFloricents = (valor) => {
        if (typeof valor !== 'string' || valor.length != 4) return false;
        const anio = valor.substring(0, 2);
        const semana = valor.substring(2, 4);
        if (isNaN(+anio) || isNaN(+semana)) return false;
        if (+semana < 1 || +semana > 53 || +anio < 20) return false;
        return true;
    }

    const changeValue = (e) => {
        const { name, value } = e.target;
        getReporte({ ...selecciones, [name]: value });
    }

    const getReporte = async (selec = { ...selecciones }) => {
        const resp = await vr.getDataAPI('reportes/siembra/ejecucion', selec);
        if (!resp || !resp.estatus) {
            setselecciones(selec);
            return;
        }
        selec.semana_inicio = resp.data.semana_inicio;
        selec.semana_fin = resp.data.semana_fin;
        setselecciones(selec);
        setreporte(resp.data.planes);
        setsemanas(resp.data.semanas || []);
        setflores(resp.data.flores || []);
        setvariedades(resp.data.variedades || []);
        setcolores(resp.data.colores || []);
    }

    const ajusteVisor = (atributo, valor) => {
        setvisor({ ...visor, [atributo]: valor });
    }

    return (
        <div className='col-lg-12 m-0 p-0 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='grid-selectores p-2'>
                <div className='form-group'>
                    <label className='text-bold'>Semana inicio</label>
                    <select className='form-control' name="semana_inicio" value={selecciones.semana_inicio} onChange={changeValue}>
                        {semanas.map((semana) => (
                            <option key={semana + "i"} value={semana}>{semana}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Semana fin</label>
                    <select className='form-control' name="semana_fin" value={selecciones.semana_fin} onChange={changeValue}>
                        {semanas.map((semana) => (
                            <option key={semana + "f"} value={semana}>{semana}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Flor</label>
                    <select className='form-control' name="flor_id" value={selecciones.flor_id} onChange={changeValue}>
                        <option value="">Todas las flores</option>
                        {flores.map((flor) => (
                            <option key={flor.id + "flor"} value={flor.id}>{flor.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Variedad</label>
                    <select className='form-control' name="variedad_id" value={selecciones.variedad_id} onChange={changeValue}>
                        <option value="">Todas las variedades</option>
                        {variedades.map((variedad) => (
                            <option key={variedad.id + "variedad"} value={variedad.id}>{variedad.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Color</label>
                    <select className='form-control' name="color_id" value={selecciones.color_id} onChange={changeValue}>
                        <option value="">Todas los colores</option>
                        {colores.map((color) => (
                            <option key={color.id + "color"} value={color.id}>{color.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='row justify-content-evenly w-100 m-0 p-0'>

                    <label className='text-bold'>Tipo de reporte</label>
                    <div className='col-lg-12 m-0 p-0'></div>
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className={`btn btn-${visor.tipo_visualizacion === 'semana' ? 'warning text-bold' : 'light border shadow'}`} onClick={() => ajusteVisor('tipo_visualizacion', 'semana')}>Semana</button>
                        <button type="button" className={`btn btn-${visor.tipo_visualizacion === 'bloque' ? 'warning text-bold' : 'light border shadow'}`} onClick={() => ajusteVisor('tipo_visualizacion', 'bloque')}>Bloque</button>
                    </div>
                </div>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-lg-12 m-0 p-0' style={{ maxWidth: "1500px", width: "100%" }}>
                    {visor.tipo_visualizacion === 'semana' && <TablaEjecucionSemana datos={reporte} />}
                    {visor.tipo_visualizacion === 'bloque' && <TablaEjecucionBloque datos={reporte} />}
                </div>
            </div>
        </div>
    )
}

export default Rpt_ejecucion_siembra;